import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
} from "@angular/core";
import { FormControl, FormControlStatus } from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
  selector: "[dynamicErrorMsg]",
  template: "{{ error }}",
  standalone: true,
})
export class DynamicErrorMsgDirective
  implements AfterViewInit, AfterViewChecked, OnDestroy
{
  error!: string;
  private statusChangesSubs!: Subscription;
  @Input() label!: string;
  @Input() control!: FormControl;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.updateErrorMsg();
  }

  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }

  private updateErrorMsg() {
    const generateErrorMssg = (state: FormControlStatus) => {
      if (state === "VALID") {
        this.error = "";
        return;
      }

      const allErrors = this.control?.errors || {};
      const firstError = Object.keys(allErrors)[0];

      switch (firstError) {
        case "required": {
          this.error = "* This field is required";
          break;
        }
        case "email":
        case "pattern": {
          this.error = `* Kindly enter a valid ${this.label}`;
          break;
        }
        case "min": {
          const minValue = allErrors[firstError].min;
          this.error = `* Minimum value should be ${minValue}`;
          break;
        }
        case "max": {
          const maxValue = allErrors[firstError].max;
          this.error = `* Maximum value should be ${maxValue}`;
          break;
        }
        case "minlength": {
          const controlMinLength = allErrors[firstError].requiredLength;
          this.error = `* Input length must be minimum ${controlMinLength}`;
          break;
        }
        case "maxlength": {
          const controlMaxLength = allErrors[firstError].requiredLength;
          this.error = `* Input length cannot exceed ${controlMaxLength}`;
          break;
        }

        case "isExist": {
          this.error = `* This ${this.label} already exists.`;
          break;
        }
        default: {
          break;
        }
      }
    };

    generateErrorMssg(this.control?.status);
    this.statusChangesSubs = this.control?.statusChanges.subscribe(
      <any>generateErrorMssg
    );
  }

  ngOnDestroy() {
    this.statusChangesSubs && this.statusChangesSubs.unsubscribe();
  }
}
